(() => {
  const desktopMedia = window.matchMedia('(min-width: 990px)');

  document.querySelectorAll('[data-hao-mobile-drawer]').forEach((drawer) => {
    const opener = drawer.querySelector('[data-hao-drawer-opener]');
    const panel = drawer.querySelector('[data-hao-drawer-panel]');
    const backdrop = drawer.querySelector('[data-hao-drawer-backdrop]');
    const closeButton = drawer.querySelector('[data-hao-drawer-close]');
    const header = drawer.closest('.hao-cd-header');
    if (!opener || !panel || !backdrop || !closeButton || !header) return;

    const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    const updateTop = () => {
      document.documentElement.style.setProperty('--hao-cd-drawer-top', `${Math.max(0, header.getBoundingClientRect().bottom)}px`);
    };

    const closeDrawer = (returnFocus = true) => {
      if (!drawer.open) return;
      drawer.open = false;
      if (returnFocus) opener.focus();
    };

    drawer.addEventListener('toggle', () => {
      const isOpen = drawer.open && !desktopMedia.matches;
      opener.setAttribute('aria-expanded', String(isOpen));
      opener.setAttribute('aria-label', isOpen ? 'Close department menu' : 'Open department menu');
      document.body.classList.toggle('hao-cd-drawer-open', isOpen);
      if (isOpen) {
        updateTop();
        window.requestAnimationFrame(() => closeButton.focus());
      }
    });

    closeButton.addEventListener('click', () => closeDrawer());
    backdrop.addEventListener('click', () => closeDrawer());
    panel.querySelectorAll('a[href]').forEach((link) => link.addEventListener('click', () => closeDrawer(false)));

    document.addEventListener('keydown', (event) => {
      if (!drawer.open || desktopMedia.matches) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = [...panel.querySelectorAll(focusableSelector)].filter((element) => element.getClientRects().length > 0);
      if (!focusable.length) {
        event.preventDefault();
        panel.focus();
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    const handleViewportChange = () => {
      if (desktopMedia.matches) closeDrawer(false);
      else if (drawer.open) updateTop();
    };
    desktopMedia.addEventListener('change', handleViewportChange);
    window.addEventListener('resize', handleViewportChange, { passive: true });
  });
})();
